import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  selectIsServicesEnabled,
  selectIsWithoutTopAndPremium,
  selectIsBlockedOfferPublishBySanctions,
} from '../../../../../../selectors/publishTerms';
import { setIsServicesEnabled } from '../../../../../../redux/reducers';
import { useIsMobileDevice } from '../../../../../../hooks';

import { ServicesLayoutToggle } from './ServicesLayoutToggle';

export const ServicesLayoutToggleContainer = () => {
  const dispatch = useDispatch();
  const isServicesEnabled = useSelector(selectIsServicesEnabled);
  const isBlockedOfferPublishBySanctions = useSelector(selectIsBlockedOfferPublishBySanctions);
  const isWithoutTopAndPremium = useSelector(selectIsWithoutTopAndPremium);
  const isMobile = useIsMobileDevice();
  const isDisabledPromotion = isBlockedOfferPublishBySanctions || isWithoutTopAndPremium;

  const toggleState = isDisabledPromotion ? false : isServicesEnabled;

  const toggleServices = React.useCallback(
    value => {
      dispatch(setIsServicesEnabled(value));
    },
    [dispatch],
  );

  return (
    <ServicesLayoutToggle
      enabled={toggleState}
      disabled={isDisabledPromotion}
      withLabel={!isMobile}
      onChange={toggleServices}
    />
  );
};
